import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerBlue, tannerGray, tannerWhite, tannerSemantic } from '../colors';

type MuiSwitch = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiSwitch'];
  defaultProps?: ComponentsProps['MuiSwitch'];
  variants?: ComponentsVariants['MuiSwitch'];
};

export const MuiSwitch: MuiSwitch = {
  defaultProps: {
    color: 'primary',
  },
  styleOverrides: {
    root: {
      width: '36px',
      height: '24px',
      padding: '0',
      margin: '4px',
      overflow: 'visible',
      '& .MuiSwitch-track': {
        backgroundColor: `${tannerGray['500']}`,
        borderRadius: '50px',
        opacity: 1,
        transition: 'background-color 200ms',
      },
      '& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-focusVisible': {
        boxShadow: `0 0 0 3px ${tannerBlue['500']}`,
        padding: '2px',
        borderRadius: '50%',
        '& + .MuiSwitch-track': {
          backgroundColor: `${tannerGray['300']}`,
        },
        '&.Mui-checked + .MuiSwitch-track': {
          backgroundColor: `${tannerSemantic.info['200']}`,
        },
        '& .MuiTouchRipple-root .MuiTouchRipple-child': {
          backgroundColor: 'transparent',
        },
      },
      '& .MuiTouchRipple-root': {
        borderRadius: '50%',
        display: 'grid',
        placeItems: 'center',
        '& .MuiTouchRipple-child': {
          width: '72%',
          height: '72%',
          borderRadius: '50%',
          margin: '3.5px',
        },
      },
    },
    colorPrimary: {
      '&.Mui-checked': {
        color: '#0060E0',
        '& + .MuiSwitch-track': {
          backgroundColor: '#0060E0',
        },
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        backgroundColor: `${tannerGray['500']}`,
        opacity: 0.3,
      },
      '&.Mui-disabled.Mui-checked + .MuiSwitch-track': {
        opacity: 0.3,
        backgroundColor: `${tannerBlue['500']}`,
      },
    },
    switchBase: {
      color: tannerGray['200'],
      padding: 2,
      '&.Mui-disabled': {
        color: '#F8F8F8',
      },
      '&.Mui-disabled div': {
        boxShadow: 'none',
        background: tannerGray[100],
      },
      '&.Mui-disabled.Mui-checked div': {
        boxShadow: 'none',
        background: tannerWhite,
      },
      '&.Mui-disabled.Mui-checked': {
        opacity: 1,
        color: '#B2D1F9',
      },
      '&:hover': {
        backgroundColor: 'transparent',
        transform: 'translateX(2px)',
      },
      '&:hover.Mui-checked': {
        transform: 'translateX(8px)',
      },
      '&.Mui-checked': {
        transform: 'translateX(10px)',
        '& + .MuiSwitch-track': {
          opacity: 1,
        },
      },
      '&.Mui-checked svg': {
        color: tannerBlue[500],
      },
      '&.Mui-disabled.Mui-checked svg': {
        opacity: 0.3,
      },
    },
    track: {
      borderRadius: '50px',
      opacity: 1,
      transition: 'background-color 200ms',
      backgroundColor: `${tannerGray['500']}`,
    },
  },
};
